<template>
  <div id="app" class="app">
    <transition name="fade">
      <div id="page" class="page" v-if="pageLoaded">
        <transition name="fade">
          <Menu
            @setAmount="setAmount"
            v-if="menuVisible"
            @scrollToSection="scrollToSection"
            :currency="currency"
            :currencyValue="currencyValue"
            :currencyCode="currencyCode"
            @changeCurrency="changeCurrency"
          />
        </transition>
        <div
          class="mob menu-icon"
          @click="toggleMenu"
          :class="{ active: menuVisible }"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <Header
          @setAmount="setAmount"
          @scrollToSection="scrollToSection"
          :currency="currency"
          :currencyValue="currencyValue"
          :currencyCode="currencyCode"
          @changeCurrency="changeCurrency"
        />
        <router-view
          @setAmount="setAmount"
          @topUp="topUp"
          @formatDate="formatDate"
          :currency="currency"
          :currencyCode="currencyCode"
          @openProductModal="openProductModal"
        />
        <Footer @goToPage="goToPage" />
        <transition name="fade">
          <ProductModal
            v-if="productModalIsVisible"
            @closeProductModal="closeProductModal"
            :currency="currency"
          />
        </transition>
        <transition name="fade">
          <Login
            v-if="signInModalIsVisible"
            @closeSignInModal="closeSignInModal"
            @login2="login2"
          />
        </transition>
        <transition name="fade">
          <TopUpModal
            v-if="topUpModalIsVisible"
            :currency="currency"
            :currencyValue="currencyValue"
            @setTopUpAmount="setTopUpAmount"
          />
        </transition>
        <transition name="fade">
          <OrderModal
            v-if="orderModalIsVisible"
            :currency="currency"
            :currencyValue="currencyValue"
            @topUp="topUp"
          />
        </transition>
        <transition name="fade">
          <OrderCartModal
            @purchase="purchase"
            v-if="orderCartModalIsVisible"
            :currency="currency"
          />
        </transition>
        <transition name="fade">
          <AgeModal v-if="ageModalIsVisible" />
        </transition>
        <transition name="fade">
          <ErrorModal v-if="errorModalIsVisible" />
        </transition>
        <transition name="fade">
          <SellModal v-if="sellModalIsVisible" />
        </transition>
        <transition name="fade">
          <ComingSoonModal
            v-if="comingSoonModalIsVisible"
            @close="closeComingSoonModal"
          />
        </transition>
        <transition name="fade">
          <WithdrawModal
            v-if="withdrawModalIsVisible && settings.payout_enabled"
            :currency="currency"
          />
        </transition>
        <transition name="fade">
          <CounterOfferModal v-if="counterOfferModalIsVisible" />
        </transition>
        <div v-if="cookesModalIsVisible" class="modal-overlay">
          <div class="cookies-modal" v-if="!settingsManagerIsVisible">
            <div class="title dark title-36">Cookies We Use</div>
            <div class="desc dark">
              We use cookies, to ensure that we give you the best experience on
              our website, toenable essential services and functionality on our
              site and to collect data on howvisitors interact with our site and
              services. By clicking Accept, you agree to our use ofall the
              cookies for advertising, analytics and support. For more
              information, pleaseread our
              <a class="desc dark" @click="goToPage('cookie')">Cookie Notice</a
              >.
            </div>
            <div class="buttons">
              <button class="button" @click="declineCookies()">
                <span>Decline</span>
              </button>
              <button class="button" @click="acceptAllCookies()">
                <span>Accept</span>
              </button>
              <button class="button" @click="settingsManagerIsVisible = true">
                <span>Manage cookies</span>
              </button>
            </div>
          </div>
          <div v-else class="cookies-modal">
            <div class="checkbox-container">
              <label class="checkbox-label">
                <div class="checkbox-label-wrapper">
                  <input
                    type="checkbox"
                    disabled
                    v-model="cookieSettings.essential"
                  />
                  <div class="checkbox"></div>
                  <div class="title small">Essential Cookies:</div>
                  <div class="desc">
                    These cookies are strictly necessary for the Website to
                    work. They enable core features like security, log-ins, and
                    page navigation. <br />Without these cookies, some parts of
                    the Website will not function properly.
                  </div>
                </div>
              </label>
            </div>

            <div class="checkbox-container">
              <label class="checkbox-label">
                <div class="checkbox-label-wrapper">
                  <input
                    type="checkbox"
                    v-model="cookieSettings.functionality"
                  />
                  <div class="checkbox"></div>
                  <div class="title small">
                    Performance & Functional Cookies
                  </div>
                  <div class="desc">
                    Remember your preferences, such as language and login
                    details, to make the Website more convenient.
                  </div>
                </div>
              </label>
            </div>

            <div class="checkbox-container">
              <label class="checkbox-label">
                <div class="checkbox-label-wrapper">
                  <input type="checkbox" v-model="cookieSettings.analytics" />
                  <div class="checkbox"></div>
                  <div class="title small">Analytics Cookies:</div>
                  <div class="desc">
                    Collect information about how you use the Website (pages
                    visited, time spent, links clicked). This information is
                    aggregated and pseudonymised before analysis.
                  </div>
                </div>
              </label>
            </div>
            <div class="checkbox-container">
              <label class="checkbox-label">
                <div class="checkbox-label-wrapper">
                  <input type="checkbox" v-model="cookieSettings.advertising" />
                  <div class="checkbox"></div>
                  <div class="title small">
                    Marketing & Advertising Cookies:
                  </div>
                  <div class="desc">
                    Help us and our partners display relevant ads to you, track
                    the performance of ads, and limit how often you see the same
                    ad
                  </div>
                </div>
              </label>
            </div>

            <div class="buttons">
              <button class="button" @click="acceptAllCookies">
                <span>Accept all</span>
              </button>
              <button @click="saveCookieSettings" class="button">
                <span>Accept selected</span>
              </button>
              <button @click="declineCookies" class="button">
                <span>Decline</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Login from './components/Login.vue'

import { loadScriptsFromString } from '@/utils/load_scripts'
import { scroller } from 'vue-scrollto/src/scrollTo'
import AgeModal from './components/AgeModal.vue'
import ComingSoonModal from './components/ComingSoonModal.vue'
import CounterOfferModal from './components/CounterOfferModal.vue'
import ErrorModal from './components/ErrorModal.vue'
import Footer from './components/Footer.vue'
import Header from './components/Header.vue'
import Menu from './components/Menu.vue'
import OrderCartModal from './components/OrderCartModal.vue'
import OrderModal from './components/OrderModal.vue'
import ProductModal from './components/ProductModal.vue'
import SellModal from './components/SellModal.vue'
import TopUpModal from './components/TopUpModal.vue'
import WithdrawModal from './components/WithdrawModal.vue'

export default {
  name: 'app',
  components: {
    Header,
    Menu,
    Footer,
    ProductModal,
    Login,
    TopUpModal,
    OrderModal,
    OrderCartModal,
    AgeModal,
    ErrorModal,
    SellModal,
    WithdrawModal,
    CounterOfferModal,
    ComingSoonModal,
  },
  data: function () {
    return {
      ageModalIsVisible: false,
      comingSoonModalIsVisible: false,
      pageLoaded: false,
      heroImagesLoaded: false,
      menuVisible: false,
      isAuth: false,
      error: '',
      successMessage: '',
      orderHistory: [],
      depositHistory: [],
      textPageTitle: '',
      textPageHeader: '',
      textPageContent: '',
      imgDomain: '',
      textPageList: '',
      currency: '',
      currencyValue: '',
      currencyCode: '',
      currencyOptions: [],
      hostname: '',
      productModalIsVisible: false,
      chosenProoduct: {},
      profileData: {},
      countryOptions: [],
      amount: null,
      socials: [],
      analyticsInitialized: false,
      settings: {},
      signInModalIsVisible: false,
      topUpModalIsVisible: false,
      orderModalIsVisible: false,
      topUpAmount: '',
      ip: '',
      port: '',
      cookesModalIsVisible: false,
      faq: [
        {
          question: 'How do I purchase items from the shop?',
          answer:
            'To purchase items, simply browse our shop, select the items you want, and follow the checkout process. We accept various payment methods for your convenience.',
        },
        {
          question: 'How do I purchase items from the shop?',
          answer:
            'To purchase items, simply browse our shop, select the items you want, and follow the checkout process. We accept various payment methods for your convenience.',
        },
        {
          question: 'How do I purchase items from the shop?',
          answer:
            'To purchase items, simply browse our shop, select the items you want, and follow the checkout process. We accept various payment methods for your convenience.',
        },
        {
          question: 'How do I purchase items from the shop?',
          answer:
            'To purchase items, simply browse our shop, select the items you want, and follow the checkout process. We accept various payment methods for your convenience.',
        },
      ],
      totalSum: '0.00',
      cartContents: [],
      orderCartModalIsVisible: false,
      errorModalIsVisible: false,
      errorModalMessage: '',
      sellModalIsVisible: false,
      withdrawModalIsVisible: false,
      inventoryItems: [],
      sellRequestHistory: [],
      sellRequestMeta: { current_page: 1, last_page: 1, total: 0 },
      counterOfferModalIsVisible: false,
      counterOfferRequest: null,
      counterOfferError: '',
      sellRequestActionLoading: false,

      cookieSettings: {
        essential: true,
        analytics: false,
        advertising: false,
        functionality: false,
      },
      settingsManagerIsVisible: false,
    }
  },
  watch: {
    $route() {
      window.scrollTo(0, 0)
      this.closeMenu()
      if (this.isAuth) {
        this.getProfileData()
        this.getCartContents()
      }
    },
  },
  methods: {
    openComingSoonModal() {
      this.comingSoonModalIsVisible = true
    },

    closeComingSoonModal() {
      this.comingSoonModalIsVisible = false
    },

    purchase(data) {
      let self = this
      this.$http
        .post(process.env.VUE_APP_API + 'cart/purchase', data)
        .then((res) => {
          if (res.data.status == 'OK') {
            if (res.data.redirect_url) {
              window.location = res.data.redirect_url
            } else {
              this.closeOrderCartModal()
              this.getOrderHistory()
              this.getCartContents()
              this.$router.push({ path: '/profile' })
            }
            this.error = ''
          } else {
            this.error = res.data.message
            setTimeout(function () {
              self.error = ''
            }, 3000)
          }
        })
        .catch((res) => {
          this.error = res.response.data.message
        })
    },
    clearCart() {
      this.$http
        .post(process.env.VUE_APP_API + 'cart/clear')
        .then(() => {
          this.getCartContents()
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignInModal()
          }
        })
    },
    removeFromCart(id) {
      let cartItem = {
        id: id,
      }

      this.$http
        .post(process.env.VUE_APP_API + 'cart/remove', cartItem)
        .then(() => {
          this.getCartContents()
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignInModal()
          }
        })
    },
    getCartContents() {
      this.$http
        .get(process.env.VUE_APP_API + 'cart/contents')
        .then((res) => {
          this.cartContents = res.data.cart.payload
          this.totalSum = res.data.cart.totalAmount
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignInModal()
          }
        })
    },
    openAgeModal() {
      this.ageModalIsVisible = true
    },
    closeAgeModal() {
      this.ageModalIsVisible = false
    },
    getFaq() {
      this.$http.get(process.env.VUE_APP_API + 'faq').then((res) => {
        this.faq = res.data.payload
      })
    },
    cookiesModal() {
      const cookiesAccepted = localStorage.getItem('cookie_consent')

      if (!cookiesAccepted) {
        this.cookesModalIsVisible = true
      }
      const storedSettings = localStorage.getItem('cookie_settings')
      if (storedSettings) {
        const parsedSettings = JSON.parse(storedSettings)
        this.cookieSettings.analytics = parsedSettings.analytics || false
        this.cookieSettings.advertising = parsedSettings.advertising || false
        this.cookieSettings.functionality =
          parsedSettings.functionality || false
      }
    },
    acceptAllCookies() {
      localStorage.setItem('cookie_consent', 'true')
      this.cookesModalIsVisible = false
      this.cookieSettings.analytics = true
      this.cookieSettings.advertising = true
      this.cookieSettings.functionality = true
      this.saveCookieSettings()
    },
    declineCookies() {
      this.cookesModalIsVisible = false
      localStorage.setItem('cookie_consent', 'false')

      // Disable all optional cookie types
      this.cookieSettings.analytics = false
      this.cookieSettings.advertising = false
      this.cookieSettings.functionality = false

      this.saveCookieSettings()
    },
    saveCookieSettings() {
      localStorage.setItem(
        'cookie_settings',
        JSON.stringify(this.cookieSettings),
      )
      this.cookesModalIsVisible = false
      localStorage.setItem('cookie_consent', 'true')
    },
    setTopUpAmount(amount) {
      this.topUpAmount = amount
      this.openOrderModal()
    },
    closeOrderModal() {
      this.orderModalIsVisible = false
    },
    closeOrderCartModal() {
      this.orderCartModalIsVisible = false
    },
    openOrderModal() {
      this.topUpModalIsVisible = false
      this.orderModalIsVisible = true
    },
    openOrderCartModal() {
      this.orderCartModalIsVisible = true
    },
    closeTopUpModal() {
      this.topUpModalIsVisible = false
    },
    openTopUpModal() {
      this.orderModalIsVisible = false
      this.topUpModalIsVisible = true
    },
    openWithdrawModal() {
      this.withdrawModalIsVisible = true
    },
    closeWithdrawModal() {
      this.withdrawModalIsVisible = false
      this.getProfileData()
    },
    openSellItemsModal() {
      this.$http
        .get(process.env.VUE_APP_API + 'user/inventory')
        .then((res) => {
          if (res.data.status === 'OK') {
            this.openSellModal(res.data.payload)
          } else {
            this.openErrorModal('Failed to load inventory')
          }
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 404) {
              this.openErrorModal(
                'Please join the game server first to sell items',
              )
            } else if (err.response.status === 503) {
              this.openErrorModal(
                'Game server is currently unavailable. Please try again later',
              )
            } else if (err.response.status === 401) {
              this.openSignInModal()
            } else {
              this.openErrorModal('Failed to load inventory')
            }
          } else {
            this.openErrorModal('Failed to load inventory')
          }
        })
    },
    openErrorModal(message) {
      this.errorModalMessage = message
      this.errorModalIsVisible = true
    },
    closeErrorModal() {
      this.errorModalIsVisible = false
      this.errorModalMessage = ''
    },
    openSellModal(items) {
      this.inventoryItems = items.map((item) => ({
        ...item,
        _quantity: 0,
        _price: item.catalog_item ? item.catalog_item.price : 0,
      }))
      this.sellModalIsVisible = true
    },
    closeSellModal() {
      this.sellModalIsVisible = false
      this.inventoryItems = []
      this.getSellRequestHistory()
    },
    getSellRequestHistory(page) {
      let url = process.env.VUE_APP_API + 'user/sell-requests'
      if (page) {
        url += '?page=' + page
      }
      this.$http
        .get(url)
        .then((res) => {
          this.sellRequestHistory = res.data.payload
          if (res.data.meta) {
            this.sellRequestMeta = res.data.meta
          }
        })
        .catch(() => {})
    },
    openCounterOfferModal(req) {
      this.counterOfferRequest = req
      this.counterOfferError = ''
      this.counterOfferModalIsVisible = true
    },
    closeCounterOfferModal() {
      this.counterOfferModalIsVisible = false
      this.counterOfferRequest = null
      this.counterOfferError = ''
    },
    approveCounterOffer() {
      if (!this.counterOfferRequest || this.sellRequestActionLoading) return
      this.sellRequestActionLoading = true
      this.counterOfferError = ''
      this.$http
        .post(
          process.env.VUE_APP_API +
            'user/sell-requests/' +
            this.counterOfferRequest.id +
            '/approve',
        )
        .then((res) => {
          if (res.data.status === 'OK') {
            this.closeCounterOfferModal()
            this.getSellRequestHistory(this.sellRequestMeta.current_page)
            this.getProfileData()
          }
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 401) {
              this.closeCounterOfferModal()
              this.openSignInModal()
            } else if (err.response.status === 503) {
              this.counterOfferError =
                'Game server is currently unavailable. Please try again later.'
            } else if (err.response.status === 409) {
              this.counterOfferError = 'This offer is no longer available.'
            } else if (err.response.data && err.response.data.message) {
              this.counterOfferError = err.response.data.message
            } else {
              this.counterOfferError = 'Something went wrong. Please try again.'
            }
          } else {
            this.counterOfferError =
              'Network error. Please check your connection.'
          }
        })
        .finally(() => {
          this.sellRequestActionLoading = false
        })
    },
    declineCounterOffer(id) {
      if (this.sellRequestActionLoading) return
      this.sellRequestActionLoading = true
      this.$http
        .post(process.env.VUE_APP_API + 'user/sell-requests/' + id + '/decline')
        .then((res) => {
          if (res.data.status === 'OK') {
            this.closeCounterOfferModal()
            this.getSellRequestHistory(this.sellRequestMeta.current_page)
          }
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 401) {
              this.openSignInModal()
            } else if (err.response.data && err.response.data.message) {
              this.openErrorModal(err.response.data.message)
            } else {
              this.openErrorModal('Something went wrong. Please try again.')
            }
          } else {
            this.openErrorModal('Network error. Please check your connection.')
          }
        })
        .finally(() => {
          this.sellRequestActionLoading = false
        })
    },
    login2() {
      this.error = ''
      this.$http
        .post(process.env.VUE_APP_API + 'user/fake-login')
        .then((res) => {
          if (res.data.status == 'OK') {
            this.isAuth = true
          }
        })
        .catch(() => {})
    },
    closeSignInModal() {
      this.signInModalIsVisible = false
    },
    openSignInModal2() {
      this.signInModalIsVisible = true
    },
    setAmount(am) {
      this.amount = am
    },
    closeProductModal() {
      this.productModalIsVisible = false
    },
    openProductModal(product) {
      this.productModalIsVisible = true
      this.chosenProoduct = product
    },
    scrollToSection(section) {
      if (this.$route.name != 'Home') {
        this.$router.push({ path: '/' })
      }
      setTimeout(() => {
        const firstScrollTo = scroller()
        firstScrollTo(section)
      }, 200)
    },
    getDomainName(hostName) {
      return hostName.substring(
        hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1,
      )
    },
    closeMenu() {
      this.menuVisible = false
      document.body.style.overflow = 'auto'
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible
      window.scrollTo(0, 0)
      if (this.menuVisible) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    },
    menuHeight() {
      const doc = document.documentElement
      doc.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    openSignInModal() {
      if (process.env.NODE_ENV !== 'production') {
        // Override baseURL to '/' because this route is in web.php, not api.php
        this.$http
          .get(process.env.VUE_APP_API + '/auth/test-login', { baseURL: '/' })
          .then(({ data }) => {
            if (data.status === 'ok') {
              this.isAuth = true
              this.getProfileData()
              this.getCartContents()
            }
          })
          .catch((error) => {
            console.error('Dev Login Failed:', error)
          })
      } else {
        // Production/Normal flow: Redirect to Steam
        window.location.replace(
          'https://api.rustlegacys.com/auth/steam/redirect',
        )
      }
    },
    logout() {
      this.$http
        .get(process.env.VUE_APP_API + 'user/logout')
        .then(() => {
          this.isAuth = true
          this.$router.push({ path: '/' })
          this.isAuth = false
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignInModal()
          }
        })
    },
    getDepositHistory() {
      this.$http
        .get(process.env.VUE_APP_API + 'payments/history')
        .then((res) => {
          this.depositHistory = res.data.data
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignInModal()
          }
        })
    },
    getOrderHistory() {
      this.$http
        .get(process.env.VUE_APP_API + 'orders/history')
        .then((res) => {
          this.orderHistory = res.data.data
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignInModal()
          }
        })
    },
    formatDate(num) {
      let objectDate = new Date(num * 1000)
      let day = objectDate.getDate()
      if (day < 10) {
        day = '0' + day
      }
      let month = objectDate.getMonth() + 1
      if (month < 10) {
        month = `0${month}`
      }
      let year = objectDate.getFullYear()

      function padTo2Digits(x) {
        return String(x).padStart(2, '0')
      }
      let hoursAndMinutes =
        padTo2Digits(objectDate.getHours()) +
        ':' +
        padTo2Digits(objectDate.getMinutes())
      let format = day + '.' + month + '.' + year + ' ' + hoursAndMinutes

      return format
    },
    openProduct(item) {
      this.$router.push({
        path: '/products/' + item.id,
        params: { data: item.id },
      })
      this.getProductPageContent(item.id)
    },
    goToPage(item) {
      let newItem
      if (item == 'privacy') {
        for (let i = 0; i < this.textPageList.length; i++) {
          if (this.textPageList[i].title.toLowerCase().includes('privacy')) {
            newItem = this.textPageList[i]
          }
        }
      } else if (item == 'terms') {
        for (let i = 0; i < this.textPageList.length; i++) {
          if (this.textPageList[i].title.toLowerCase().includes('terms')) {
            newItem = this.textPageList[i]
          }
        }
      } else if (item == 'cookie') {
        for (let i = 0; i < this.textPageList.length; i++) {
          if (this.textPageList[i].title.toLowerCase().includes('cookie')) {
            newItem = this.textPageList[i]
          }
        }
      } else {
        newItem = item
      }
      this.$router.push({
        path: '/pages/' + newItem.slug,
        params: { data: newItem },
      })

      this.getTextPageContent(newItem.id)
    },
    getTextPageContent(id) {
      this.textPageTitle = ''
      this.textPageHeader = ''
      this.textPageContent = ''
      this.$http
        .get(process.env.VUE_APP_API + 'static-pages/' + id)
        .then((res) => {
          this.textPageTitle = res.data.payload.title
          this.textPageContent = res.data.payload.content
          this.textPageHeader = res.data.payload.header
        })
    },
    getTextPages() {
      this.$http.get(process.env.VUE_APP_API + 'static-pages').then((res) => {
        this.textPageList = res.data.payload
      })
    },
    getSettings() {
      return this.$http
        .get(process.env.VUE_APP_API + 'settings')
        .then(async (res) => {
          this.ip = res.data.payload.game_server.host
          this.port = res.data.payload.game_server.port
          this.settings = res.data.payload
          const snippet = res.data.payload.google_tag
          if (!this.analyticsInitialized && snippet) {
            await loadScriptsFromString(snippet)
            this.analyticsInitialized = true
          }
        })
        .catch(() => {})
    },
    getSocials() {
      this.$http
        .get(process.env.VUE_APP_API + 'social-links')
        .then((res) => {
          this.socials = res.data.payload
        })
        .catch((res) => {
          console.log(res)
        })
    },
    topUp(data) {
      let self = this
      this.$http
        .post(process.env.VUE_APP_API + 'payments/checkout', data)
        .then((res) => {
          if (res.data.status == 'OK') {
            window.location = res.data.redirect_url
          } else {
            this.error = res.data.message
            setTimeout(function () {
              self.error = ''
            }, 3000)
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignInModal()
          } else {
            this.error = res.response.data.message
          }
        })
    },
    getProfileData() {
      let self = this
      self.$http
        .get(process.env.VUE_APP_API + 'user/profile')
        .then((res) => {
          self.getOrderHistory()
          self.getDepositHistory()
          self.getSellRequestHistory()
          self.profileData = res.data.payload
        })
        .catch(() => {})
    },
    getCurrencies() {
      return this.$http
        .get(process.env.VUE_APP_API + 'currencies')
        .then((res) => {
          const that = this
          this.currencyOptions = res.data.payload

          if (localStorage.getItem('currency')) {
            this.currencyCode = localStorage.getItem('currency')

            const currency = res.data.payload.find(
              ({ code }) => code === that.currencyCode,
            )

            if (currency) {
              this.currencyValue = currency.value
              this.currency = currency.symbol
            }
          } else {
            this.currencyCode = this.currencyOptions[0].code
            this.currency = this.currencyOptions[0].symbol
            this.currencyValue = this.currencyOptions[0].value
          }
        })
        .catch(() => {})
    },
    changeCurrency(item) {
      this.currencyCode = item
      this.checkCurrency()
    },
    checkCurrency() {
      const that = this
      const currency = this.currencyOptions.find(
        ({ code }) => code === that.currencyCode,
      )

      if (currency) {
        this.currency = currency.symbol
        this.currencyValue = currency.value
        console.log(currency.symbol)

        if (this.isAuth) {
          this.getProfileData()
          this.getCartContents()
        }
      }
    },
  },
  mounted: function () {
    let self = this
    this.getFaq()
    this.cookiesModal()
    this.pageLoaded = true
    setTimeout(function () {
      self.heroImagesLoaded = true
    }, 1000)
    this.hostname = this.getDomainName(window.location.hostname)
    this.currency = process.env.VUE_APP_CURRENCY
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN
    window.addEventListener('resize', self.menuHeight)
    self.getSettings()
    self.menuHeight()
    self.getTextPages()
    self.getSocials()
    self.getCurrencies()

    self.$http
      .get(process.env.VUE_APP_API + 'user/is-auth')
      .then((res) => {
        console.log('auth: ' + res.data.authenticated)
        self.isAuth = res.data.authenticated

        if (res.data.authenticated) {
          self.getProfileData()
          self.getCartContents()
        }
      })
      .catch(() => {})
  },
  computed: {
    minOrderAmount: function () {
      return this.settings && this.settings.min_order_amount
    },
  },
}
</script>
